const CACHE_PREFIX = 'rb-store-detail:';

export function setStoreDetailsCache(storeId, data) {
  if (!storeId || data == null) return;
  try {
    sessionStorage.setItem(`${CACHE_PREFIX}${storeId}`, JSON.stringify(data));
  } catch {
    /* ignore quota / private mode */
  }
}

export function getStoreDetailsCache(storeId) {
  if (!storeId) return null;
  try {
    const raw = sessionStorage.getItem(`${CACHE_PREFIX}${storeId}`);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
